<script>
  import MiniCard from "./UC-mini-card.svelte";

  export let groupCode = "COM";
  export let itemClasses = "";
  export let isLoading = false;
  export let showAllSchools = false | Boolean;
  export let isBusinessUnit = false;

  export let data = []

  const loadingObject = {
    OverallScore: undefined,
    ConditionalGroupName : undefined,
    GroupName: undefined,
  }

  // initialize with dummy values for loading
  let leftCol = Array(7).fill(loadingObject)
  let rightCol = Array(6).fill(loadingObject)

  function getOrdinalSuffix(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  function getPrefixedRank(i) {
    if (isBusinessUnit) {
      return "Business Unit " + i;
    } else {
      return "College " + i;
    }
  }

  function sortData(data) {
    return data.sort(function (a, b) {
      return b.OverallScore - a.OverallScore;
    });
  }

  function rankData(data) {
    var prevRank = 0,
      prevScore = 0;

    return data.map(function (ele, i, elements) {
      if (i === 0) {
        // first item
        ele.rank = 1;
        ele.isTie = false;
      } else if (
        Number(ele.OverallScore).toFixed(3) === Number(prevScore).toFixed(3)
      ) {
        // it's a tie!
        ele.rank = prevRank;
        ele.isTie = true;
      } else {
        // this val is less; next rank
        ele.rank = prevRank + 1;

        // check the next element to determine whether this one isTie
        if (i + 1 >= i.length) {
          if (
            Number(elements[i + 1].OverallScore).toFixed(3) ===
            Number(ele.OverallScore).toFixed(3)
          ) {
            ele.isTie = true;
          } else {
            ele.isTie = false;
          }
        }
      }

      prevRank = ele.rank;
      prevScore = ele.OverallScore;
      return ele;
    });
  }

  function anonymizeData(data) {
    // return data;
    return data.map(function (ele) {
      if (ele.GroupCode == groupCode) {
        // flag the school we want to spotlight in the UI
        // ele.GroupShortName = ele.GroupShortName + (ele.isTie ? ' (tie)' : '');
        // ele.GroupName = ele.GroupName + (ele.isTie ? ' (tie)' : '');
        ele.isSpotlighted = true;
      } else {
        // anonymize all other GroupNames
        ele.isSpotlighted = false;
        ele.GroupShortName = getPrefixedRank(ele.rank);
        ele.GroupName = ele.GroupShortName;
      }

      return ele;
    });
  }

  function partitionData() {
    let tmpData = Array.from(data);

    rightCol = [];
    leftCol = [];

    // if we have an odd number, we'll stack the left column with the extra item
    let leftColLength = Math.floor(tmpData.length / 2) + (tmpData.length % 2);
    let rightColLength = tmpData.length - leftColLength;

    for (let step = 0; step < rightColLength; step++) {
      // let's slam through this loop real quick and make ourselves a right column
      rightCol.push(tmpData.pop());
    }

    // what remains will go into our left column
    leftCol = tmpData;

    // reverse the right column
    rightCol.reverse();
  }

  function processData() {
    /* data = sortData(data);
     data = rankData(data);
    if(showAllSchools) {
      // nothing yet
    } else {
      data = anonymizeData(data);
    }*/

    partitionData();

    return data;
  }

  $: if(data.length > 0) processData(data);
</script>

<div class="leaderboard" aria-live="polite" aria-busy={isLoading}>
  <h3>College Rankings</h3>
  <div class="column-wrapper">
    <div class="left-col">
      {#each leftCol as { OverallScore, ConditionalGroupName, GroupName }, i}
        <div class="leaderboard-item {itemClasses}">
          <MiniCard
            value={OverallScore ? (OverallScore * 1).toFixed(1) : undefined}
            name={i < 5 ? GroupName : ConditionalGroupName}
          />
        </div>
      {/each}
    </div>

    <div class="right-col">
      {#each rightCol as { OverallScore, ConditionalGroupName, OverallScoreLabel }, i}
        <div class="leaderboard-item {itemClasses}">
          <MiniCard
            value={OverallScore ? (OverallScore * 1).toFixed(1) : undefined}
            name={ConditionalGroupName}
          />
        </div>
      {/each}
    </div>
  </div>
</div>

<style lang="scss">
  .leaderboard h3 {
    font-size: 3rem;
    font-weight: 600;
    position: relative;
    color: #e00122;
    margin: 0 0 1.5rem;
  }
  .leaderboard .column-wrapper {
    display: flex;
    flex-flow: row wrap;
    gap: 0 20px;
  }

  .left-col,
  .right-col {
    width: 100%;
    flex-grow: 1;
    flex-basis: 45%;
    min-width: 28.1rem;
  }

  .leaderboard-item {
    margin-bottom: 20px;
  }
</style>
